module.exports = __webpack_public_path__ + "img/kdalogo.716721bb.png";